import { useEffect } from 'react';
import { AssessmentLoader } from './AssessmentLoader';
import styles from './AssessmentReport.module.css';
import dynamic from 'next/dynamic';
import { IAssessmentCmsContent } from '@/interfaces/IAssessmentData';
import { HowItWorks, OurMedicalBoard } from '../homePage';
import { CaseStudies } from '../category';
import { AssessmentRootCause } from './AssessmentRootCause';
import { AssessmentProductPlan } from './AssessmentProductPlan';
import { AssessmentAccreditation } from './AssessmentAccreditation';
type props = {
    assessmentResult: any,
    assessmentCmsContent: IAssessmentCmsContent
}
export function AssessmentReport({ assessmentResult, assessmentCmsContent }: props) {
    useEffect(() => {
        const hiddenDiv: any = document.getElementById('hiddenDiv');
        const revealOffset = 1600;
        function revealHiddenDiv() {
            if (window.scrollY >= revealOffset) {
                hiddenDiv.classList.remove('hidden');
            } else {
                hiddenDiv.classList.add('hidden');
            }
        }
        if (Object.keys(assessmentResult).length > 0) {
            window.addEventListener('scroll', revealHiddenDiv);
            revealHiddenDiv();
        }
    }, [assessmentResult])
    if (!Object.keys(assessmentResult).length && !Object.keys(assessmentCmsContent).length) return <AssessmentLoader />;
    const productPriceDetails = assessmentResult && assessmentResult.product_price_detail_arr && assessmentResult.product_price_detail_arr;
    const AssessmentChart = dynamic(() => import('./AssessmentChart'), { ssr: false });
    return <>
        <section className={`${styles.banner_assessment} ${styles.grdient_effect_1} pt20 pb10`}>
            <div className="container">
                <div className={`${styles.text_details} textcenter`}>
                    <h3 className="text505257 font30 fontThin mb10">Hello<b className="text46675"> {assessmentResult && assessmentResult?.customer_details?.customer_name}</b> </h3>
                    <h5 className="text505257 font20 fontsemiBold">You have been diagnosed with <span className="fontBold">{assessmentResult && assessmentResult?.assessement_score && assessmentResult?.assessement_score[0]?.question_segment_name}</span> of <b className="text46675">{`${assessmentResult.assessement_score[0].stage} Stage`}</b></h5>
                    <h4 className="text505257 font25 fontsemiBold"></h4>
                </div>
            </div>
        </section>
        <AssessmentChart bmiMaxVal={assessmentResult.bmi_score} gaugeData={assessmentResult.assessement_score}/>
        <section className={`${styles.Moderate_details}  pb50 textcenter`}>
            <div className="container">
                <div className={styles.grid_items}>
                    <div className={styles.Warpper_ResultShow}>
                        <div id='chartdiv' className={styles.chartdiv}></div>
                        <div className={styles.assessmentResult}>
                            <p className={styles.segmentName}>{assessmentResult?.assessement_score[0]?.sub_category_name}</p>
                            <p className={styles.segmentResult}>{assessmentResult?.assessement_score[0]?.stage}</p>
                        </div>
                    </div>
                    <div className={styles.screening_progress_parent}>
                        <div className={styles.screening_progress}>
                            {assessmentResult.bmi_score.bar_master_arr.map((f: any, idx: number) =>
                                <div className={`${styles.progress_percent} ${f.className}`} key={idx}>{f.label}</div>
                            )}
                        </div>
                        <div className={`${styles.baloon_design} baloon_design`}>
                            <img src="/assets/images/bmiscore.png" />
                            <span className={`${styles.bmiScore} ${styles.bmiScoreValue}`} id="bmiScoreValue"></span>
                        </div>
                    </div>
                    <div className={styles.Warpper_ResultShow}>
                        <div id="chartdivs" className={styles.chartdivs}></div>
                        <div className={styles.assessmentResult}>
                        <p className={styles.segmentName}>{assessmentResult?.assessement_score[1]?.sub_category_name}</p>
                            <p className={styles.segmentResult}>{assessmentResult?.assessement_score[1]?.stage}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <AssessmentRootCause data={assessmentResult?.root_cause} />
        <AssessmentProductPlan data={assessmentResult} />
        <section className={`${styles.out_comes_assessment} pt40 pb40`}>
            <div className="container">
                <div className={`${styles.outcomes_details} textcenter`}>
                    <h2 className="sectionHeading">{assessmentCmsContent.our_outcomes_title}</h2>
                    <div className={styles.resultsgrid}>
                        {assessmentCmsContent.our_outcomes_content?.map((f, idx) =>
                            <div className={styles.istGrid} key={idx}>
                                <div className={`${styles.progressBar}`} style={{ background: `radial-gradient(closest-side, white 83%, transparent 85% 36%), conic-gradient(#466759 ${f.title}, #E0F9EE 0)` }}>
                                    <p className="font35 fontsm18 font600 text46675">{f.title}</p>
                                </div>
                                <p className="font16 fontsm16 fontMedium text666">{f.content}</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
        <HowItWorks howItWorksData={assessmentCmsContent?.how_its_work} isAssessment={true} />
        <div id="hiddenDiv" className={styles.hiddenDiv}>
            <a className={`buy_now_btn button`} href='#buyNow'>
                <div className={styles.g_foot}>
                    <div className={styles.coupon_data}>
                        <div>
                            <h4 className="textfff font20 fontsm16">Your Plan <span className={`${styles.textfff} fontThin`}>₹ {productPriceDetails.total_price_without_discount}</span> <b className="font30 textfff"> ₹ {productPriceDetails.total_price_with_discount} </b> </h4>
                        </div>
                    </div>
                    <div className={`${styles.plan_tretBox} mp-0`}><button className={`${styles.button} buyNowBtn`}>Buy Now</button></div>
                </div>
            </a>
        </div>
        <AssessmentAccreditation data={assessmentCmsContent.our_accreditation} />
        <CaseStudies caseStudies={assessmentCmsContent.case_studies} colors={{ dark: '#466759', light: '#F5F5F5', semiDark: '#F5F5F5;' }} isAssessment={true} />
        <OurMedicalBoard doctorsList={assessmentCmsContent.our_medical_board} colors={{ dark: '#466759', light: '#fff', semiDark: '' }} />
    </>
}